<template>
    <div class="header border-b-2 py-4 flex">
        <div class="">
            <img src="../assets/image/stm-b.png" alt="STM Logo" width="80">
        </div>
        <div class="flex-1 ml-3 pt-1">
            <div class="flex justify-between uppercase tracking-wide text-xs font-bold text-black mb-1 leading-tight">
                <div>Step: {{ step }} of 2</div>
                <div>ชื่อ : {{ employee_name }}</div>
            </div>
            <div class="flex flex-col md:flex-row md:items-center md:justify-between">
                <div class="flex-1">
                    <div v-if="step === 1">
                        <div class="text-lg font-bold text-black leading-tight">
                            สินค้า
                        </div>
                    </div>

                    <div v-if="step === 2">
                        <div class="text-lg font-bold text-black leading-tight">
                            ตรวจสอบข้อมูล
                        </div>
                    </div>
                </div>

                <div class="flex items-center md:w-64">
                    <div class="w-full bg-gray-200 rounded-full mr-2">
                        <div
                            class="rounded-full bg-green-500 text-xs leading-none h-2 text-center text-white"
                            :style="step === 1 ? 'width:0%' : 'width:100%'"></div>
                    </div>
                    <div class="text-xs w-10 text-black">{{ step === 1 ? 0 : 100 }}%</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Header",
        props: ['step'],
        data() {
            let userStorage = localStorage.getItem('user')
            let userStorageJSON = JSON.parse(userStorage)
            let employee_name = userStorageJSON['employee_name']
            return {
                employee_name
            }
        },
    };
</script>

<style>
    
</style>
